export default __webpack_public_path__ + "static/media/etapa7.3a1c359f.png";